import { logConstants } from '../../../utils/Constants';
import { Logger } from '../../../auth/Logger';
import { getTimeoutValue } from '../../../Common/getTimeoutValue';
import {
	ParsedRequirementNode,
	RequirementNodeParser,
} from '../../../Common/Parsers/RequirementNodeParser';
import { AuthenticateResponse } from './AuthenticateResponse';

export class FormsAuthenticateResponse extends AuthenticateResponse {
	private status: string;
	private result: string;
	private stateContext: string;
	private requirements: ParsedRequirementNode[];
	private timeoutSeconds: number | null;

	constructor(
		status: string,
		result: string,
		postBack: string,
		cancelPostback: string,
		stateContext: string,
		requirements?: string,
		requirementNodes?: ParsedRequirementNode[],
		timeoutSeconds?: number | null
	) {
		super(postBack, cancelPostback);
		this.status = status;
		this.result = result;
		this.stateContext = stateContext;
		this.requirements = requirementNodes
			? requirementNodes
			: RequirementNodeParser.parseRequirementNodes(requirements);
		if (timeoutSeconds > 0) {
			this.timeoutSeconds = timeoutSeconds;
		} else {
			try {
				this.timeoutSeconds = getTimeoutValue(requirements);
			} catch (e) {
				this.timeoutSeconds = null;
				Logger.getInstance().write(logConstants.ERROR, e.message);
			}
		}
	}

	getStatus(): string {
		return this.status;
	}

	getResult(): string {
		return this.result;
	}

	getStateContext(): string {
		return this.stateContext;
	}

	getRequirements(): ParsedRequirementNode[] {
		return this.requirements;
	}

	getTimeOut(): number | null {
		return this.timeoutSeconds;
	}
}
